module.exports = __webpack_public_path__ + "img/jobsmedia-logo.49a27d0d.png";